import axios from "axios";
import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
import {
  clearAuthSlice,
  fetchingUserDetails,
  setIsAuthenticated,
  setNotification,
  setUserDetails,
} from "../redux/slices/userSlice";
import DataStorage from "../utils/DataStorage";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
    isCrimeRisk: true,
  },
});
export const AuthInterceptor = () => {
  const dispatch = useDispatch();
  // const navigate = useNavigate();

  const logout = (reject) => {
    dispatch(setIsAuthenticated(false));
    dispatch(fetchingUserDetails(false));
    dispatch(clearAuthSlice());
    // dispatch(resetMapState());
    DataStorage.clear();
    setTimeout(() => {
      window.location.href = "/sign-in";
      reject();
    }, 500);
  };

  // Get refresh token
  const getRefreshToken = (originalRequest, resolve, reject) => {
    const payloadRefreshToken = localStorage.getItem("refreshToken");
    if (payloadRefreshToken) {
      axiosInstance
        .post("auth/refreshToken", {
          refreshToken: payloadRefreshToken,
          isCrimeRisk: true,
        })
        .then((response) => {
          if (response && response.status === 200) {
            const { refreshToken, accessToken, user } = response.data.data;
            localStorage.setItem("accessToken", accessToken);
            localStorage.setItem("refreshToken", refreshToken);
            dispatch(
              setNotification({
                isNotification: user.paymentNotificationEnabled,
              })
            );
            dispatch(setUserDetails(user));
            originalRequest.headers.Authorization = `Bearer ${accessToken}`;
            axios.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${accessToken}`;
            resolve(axiosInstance(originalRequest));
          } else {
            logout(reject);
          }
        })
        .catch((error) => {
          logout(reject);
        });
    } else {
      logout(reject);
    }
  };

  // Request interceptor
  axiosInstance.interceptors.request.use(
    async function (config) {
      // Updating the request header.
      if (!config.headers["Content-Type"]) {
        config.headers["Content-Type"] = "application/json";
        config.headers.Accept = "application/json";
      }
      config.headers["Access-Control-Allow-Origin"] = "*";
      config.headers["Access-Control-Allow-Methods"] =
        "POST, GET, PUT, OPTIONS, DELETE";
      config.headers["app-type"] = "userApp";
      let token = localStorage.getItem("accessToken");
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  // Response interceptor
  axiosInstance.interceptors.response.use(
    function (response) {
      return response;
    },
    async function errorHandler(error) {
      const axiosError = await Promise.resolve(error);
      const originalRequest = axiosError.config;

      const promise = new Promise((resolve, reject) => {
        if (axiosError.response && axiosError.response.status === 403) {
          logout(() => reject(axiosError)); // Need to handle the permission error.
        } else if (
          axiosError.response &&
          axiosError.response.status === 401 &&
          !originalRequest._retry
        ) {
          originalRequest._retry = true;
          getRefreshToken(originalRequest, resolve, () => reject(axiosError));
        } else {
          reject(axiosError);
        }
      });
      return promise;
    }
  );
};
export default axiosInstance;
